import React from 'react'
import {createSearchParams, Link, useNavigate} from "react-router-dom";
import Sidebar from "../../../../../components/Sidebar";
import PageHeader from "../../../../../components/PageHeader";
import {toast} from "react-toastify";
import DatePicker, {registerLocale} from "react-datepicker";
import {getSchoolYear} from "../../../../../utils/authority";
import StudentController from "../../../../../services/system/student/student-controller";
import vi from "date-fns/locale/vi";
import TableHeader from "../../../../../components/TableHeader";
import Pagination from "../../../../../components/Pagination";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import BusRouteController from "../../../../../services/system/bus/bus-route-controller";
import Utils from "../../../../../utils/utils";
import ModalCancelRegisterBus from "../modalCancelRegisterBus";
import BusTypeController from "../../../../../services/system/bus/bus-type-controller";
import ModalDetailRegisterBus from "../modalDetailRegisterBus";
registerLocale("vi", vi);
function withRouter(Component) {
    return (props) => <Component {...props} navigate={useNavigate()} />;
}
class CreateBusRegisterManagement extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            routeBusName: "",
            driverName: "",
            busRouteId: -1,
            billNumber: 0,
            paidMoneyTotal: 0,
            paidNumber: 0,
            remainMoneyTotal: 0,
            seatNumber: 0,
            seatNumberRegistered: 0,
            listRouteBus: [],
            busRouteType: [],
            discount: 0,
            reasonDiscount: "",
            stateService: "NEW_REGISTER",
            startDay: new Date(),
            totalMoney: 0,
            busTypePos: -1,
            assistant1Id: -1,
            assistant1Name: "",
            assistant1Username: "",

            assistant2Id: -1,
            assistant2Name: "",
            assistant2Username: "",

            assistant3Id: -1,
            assistant3Name: "",
            assistant3Username: "",
            defaultBusPrices: [],
            busStopRes: [],
            busUserServiceRes: [],
            listStudent: [],
            studentName: "",
            studentId: -1,
            month: 0,


            activeDate: null,
            content: "",
            pageNumber: 0,
            pageSize: 10,
            header: [
                {
                    id: "123",
                    name: "STT",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "title",
                    name: "Tên học sinh",
                    style: {textAlign: "left"},
                    sort: false
                },
                {
                    id: "startDate",
                    name: "Loại dịch vụ",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "startDate",
                    name: "Điểm đón xe bus",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "type",
                    name: "Giá",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "type",
                    name: "Số tháng đóng phí",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "type",
                    name: "Giảm giá",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "type",
                    name: "Lý do giảm",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "payment",
                    name: "Trạng thái",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "",
                    name: "Hủy dịch vụ",
                    style: {minWidth: 120, textAlign: "center"},
                    sort: false
                }
            ],
        };
    }

    componentWillMount() {
        this.getListRouteBus()
        this.getListStudent()
    }
    renderStatus() {
        let listStatus = [
            {
                "id": "All",
                "name": "Tất cả"
            },
            {
                "id": "PENDING",
                "name": "Chưa thanh toán"
            },
            {
                "id": "PAYMENT",
                "name": "Đã thánh toán"
            },
        ]
        return listStatus.map((item, index) => <option
            value={item.id}>{item.name}</option>)
    }
    getTotalMoney(){
        console.log(this.state.totalMoney)
        let discount = parseInt(this.state.discount.toString().replaceAll(",", ""))
        return Utils.formatMoney(parseInt(this.state.totalMoney) - discount)
    }
    onCreate = () => {
        let discount = parseFloat(this.state.discount.toString().replaceAll(",", ""))
        if (this.state.busRouteId < 0){
            toast.error("Vui lòng chọn tuyến xe bus");
        }else if(this.state.busStopId < 0){
            toast.error("Vui lòng chọn điểm đón/trả");
        }else if(this.state.busRouteTypeId < 0){
            toast.error("Vui lòng chọn dịch vụ xe bus");
        }else if(this.state.month < 1){
            toast.error("Vui lòng chọn số tháng đóng phí");
        }else if(this.state.studentId < 0){
            toast.error("Vui lòng chọn học sinh");
        }
        else {
            let payload = {
                "addressHome": this.state.addressHome,
                "busRouteId": this.state.busRouteId,
                "busStopId": this.state.busStopId,
                "busRouteTypeId": this.state.busRouteTypeId,
                "discount": discount,
                "priceType": this.state.month,
                "reasonDiscount": this.state.reasonDiscount,
                "startDay": this.state.startDay,
                "studentId": this.state.studentId
            }
            BusRouteController.registerBusUserService(payload, res => {
                if (res.success){
                    toast.success("Đăng ký thành công!")
                    this.setState({
                        showLoading: false,
                    });
                    this.getDetailRouteBusRegister(this.state.busRouteId)
                } else {
                    toast.error("Đã xảy ra lỗi! " + res.message)
                }
            })
        }
    }

    getListRouteBus() {
        let payload = {
            yearId: parseInt(getSchoolYear()),
            assistant1Name: "",
            busRouteName: "",
            driverName: "",
            pageNumber: 0,
            pageSize: 100,
            sort: "created_at desc",
            state: "ACTIVE",
        };
        BusRouteController.search(payload, res => {
            this.setState({
                showLoading: false,
                listRouteBus: res.data.content,
            });
        })
    }
    getDetailRouteBusRegister(busId) {
        BusRouteController.detailRegister(busId, res => {
            if (res.success){
                if (res.data.assistant1Res != null){
                    this.setState({
                        assistant1Id: res.data.assistant1Res["officerId"],
                        assistant1Name: res.data.assistant1Res["fullName"],
                        assistant1Username: res.data.assistant1Res["username"],
                    })
                }
                if (res.data.assistant2Res != null){
                    this.setState({
                        assistant2Id: res.data.assistant2Res["officerId"],
                        assistant2Name: res.data.assistant2Res["fullName"],
                        assistant2Username: res.data.assistant2Res["username"],
                    })
                }
                if (res.data.assistant3Res != null){
                    this.setState({
                        assistant3Id: res.data.assistant3Res["officerId"],
                        assistant3Name: res.data.assistant3Res["fullName"],
                        assistant3Username: res.data.assistant3Res["username"],
                    })
                }
                this.setState({
                    busRouteName: res.data.name,
                    driverName: res.data.driverName,
                    driverPhone: res.data.driverPhone,
                    busStopRes: res.data.busStopRes,
                    busUserServiceRes: res.data.busUserServiceRes,
                    paidMoneyTotal: res.data.paidMoneyTotal,
                    paidNumber: res.data.paidNumber,
                    remainMoneyTotal: res.data.remainMoneyTotal,
                    seatNumber: res.data.seatNumber,
                    seatNumberRegistered: res.data.seatNumberRegistered,
                    defaultBusPrices: res.data.defaultBusPrices,
                    busRouteType: res.data.busRouteType,
                })
            }else {
                toast.error("Đã xảy ra lỗi! " + res.message)
            }
        })
    }
    getListStudent() {
        let payload = {
            yearId: parseInt(getSchoolYear()),
            classRoomId: -1,
            code: "",
            ethnic: "",
            fullName: this.state.studentName,
            gender: "",
            grade: "",
            pageNumber:0,
            pageSize: 100,
            sort: "created_at desc",
            studentState: "",
        };
        StudentController.search(payload, res => {
            this.setState({
                listStudent: res.data.content,
            });
        })
    }
    renderBusStop() {
        return this.state.busStopRes.map((item, index) => <option
            value={item.id}>{item.name}</option>)
    }
    renderMonthFee() {
        return this.state.defaultBusPrices.map((item, index) => <option
            value={item.number}>{item.name}</option>)
    }
    renderBusType() {
        return this.state.busRouteType.map((item, index) => <option
            value={index}>{item.busTypeRes["name"]}</option>)
    }
    updateViewCancel() {
        this.getDetailRouteBusRegister(this.state.busRouteId)
    }
    getStateUserReg(state){
        if (state == "CANCEL"){
            return <span className="badge badge-danger" style={{color: "white"}}>Đã hủy</span>
        }else if (state == "NEW_REGISTER"){
            return <span className="badge bg-primary" style={{color: "white"}}>Đăng ký mới</span>
        }else if (state == "ACTIVE"){
            return <span className="badge badge-info" style={{color: "white"}}>Hoạt động</span>
        }else if (state == "PAID"){
            return <span className="badge badge-success" style={{color: "white"}}>Đã thanh toán</span>
        }else if (state == "INACTIVE"){
            return <span className="badge badge-dark" style={{color: "white"}}>Đã khóa</span>
        }
    }
    render() {
        let {header} = this.state
        let busUserServiceRes = []
        if (this.state.filterBusStopId > 0){
            busUserServiceRes = this.state.busUserServiceRes.filter(item => item.busStopRes?.id == this.state.filterBusStopId)
        }else {
            busUserServiceRes = this.state.busUserServiceRes
        }
        return (
            <div>
                <div className="container">
                    <div className="row">
                        <Sidebar activeClass="register-bus" parentClass="bus-management"/>
                        <div className="mb-4 col-md-10 tab-content">
                            <div className="card col-12">
                                <div className='pt-3 mb-2'>
                                    <PageHeader routerEnable={true} title="Đăng ký tuyến xe bus"/>
                                    <div className="mt-4 kt-form kt-form--fit kt-margin-b-20">
                                        <h2 className='text-center mb-4'>Đăng ký tuyến xe bus</h2>
                                        <div className="row">
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Chọn tuyến xe bus</label>
                                                <Autocomplete
                                                    size="small"
                                                    options={this.state.listRouteBus}
                                                    getOptionLabel={option => option.name?option.name:"No Name"}
                                                    style={{width: '100%'}}
                                                    inputValue={this.state.routeBusName}
                                                    renderInput={params => {
                                                        return <TextField
                                                            placeholder='Nhập tên tuyến xe bus'
                                                            {...params}
                                                            InputLabelProps={{
                                                                shrink: true,
                                                                style: {
                                                                    fontSize: 17,
                                                                    backgroundColor: "#FFF",
                                                                    paddingRight: 10,
                                                                    paddingLeft: 10,
                                                                    color: '#2e495c',
                                                                    fontWeight: 500,
                                                                    fontFamily: 'Montserrat'
                                                                }
                                                            }}
                                                            label=""
                                                            variant="outlined"
                                                            fullWidth
                                                        />
                                                    }}
                                                    onInputChange={(event, val) => {
                                                        if (event !== null){
                                                            this.setState({
                                                                routeBusName: val
                                                            })
                                                            if (val === ""){
                                                                this.state.busRouteId = -1;
                                                            }
                                                        }
                                                    }}
                                                    onChange={(e, val) => {
                                                        if (val?.id != undefined){
                                                            this.setState({
                                                                busRouteId: val?.id,
                                                                routeBusName: val?.name,
                                                            }, ()=>{
                                                                this.getDetailRouteBusRegister(val?.id)
                                                            })
                                                        }else {
                                                            this.setState({
                                                                busRouteId: -1,
                                                                routeBusName: "",
                                                            })
                                                        }
                                                        // this.getListPeopleInCharge()
                                                    }}

                                                />
                                            </div>

                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2"></div>
                                            <div className="col-12 d-flex mb-2 bg-top-title mt-2">
                                                Thông tin tuyến xe bus
                                            </div>
                                            <div className="col-12 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Tên tuyến xe bus</label>
                                                <label className="col-8 label-item pl-0"><b>{this.state.busRouteName}</b></label>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Tài xế xe bus</label>
                                                <label className="col-8 label-item pl-0"><b>{this.state.driverName}</b></label>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Phụ xe 1</label>
                                                <label className="col-8 label-item pl-0"><b>{this.state.assistant1Name}</b></label>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Phụ xe 2</label>
                                                <label className="col-8 label-item pl-0"><b>{this.state.assistant2Name}</b></label>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Phụ xe 3</label>
                                                <label className="col-8 label-item pl-0"><b>{this.state.assistant3Name}</b></label>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Số chỗ trống</label>
                                                <label className="col-8 label-item pl-0"><b>{this.state.busUserServiceRes.length}/{this.state.seatNumber}</b></label>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Thanh toán</label>
                                                <label className="col-8 label-item pl-0"><b>{this.state.paidNumber}/{this.state.busUserServiceRes.length}</b></label>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Tổng tiền đã thanh toán</label>
                                                <label className="col-8 label-item pl-0"><b>{Utils.formatMoney(this.state.paidMoneyTotal)} đ</b></label>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Tổng tiền còn lại</label>
                                                <label className="col-8 label-item pl-0"><b>{Utils.formatMoney(this.state.remainMoneyTotal)} đ</b></label>
                                            </div>

                                            <div className="col-12 d-flex mb-2 bg-top-title mt-2">
                                                Đăng ký dịch vụ xe bus
                                            </div>

                                            <div className="col-12 d-flex row mt-3">
                                                <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                    <label className="col-4 label-item pl-0">Chọn học sinh</label>
                                                    <Autocomplete
                                                        size="small"
                                                        options={this.state.listStudent}
                                                        getOptionLabel={option => option.fullName?option.fullName:""}
                                                        style={{width: '100%'}}
                                                        inputValue={this.state.studentName}
                                                        renderInput={params => {
                                                            return <TextField
                                                                placeholder='Nhập tên học sinh'
                                                                {...params}
                                                                InputLabelProps={{
                                                                    shrink: true,
                                                                    style: {
                                                                        fontSize: 17,
                                                                        backgroundColor: "#FFF",
                                                                        paddingRight: 10,
                                                                        paddingLeft: 10,
                                                                        color: '#2e495c',
                                                                        fontWeight: 500,
                                                                        fontFamily: 'Montserrat'
                                                                    }
                                                                }}
                                                                label=""
                                                                variant="outlined"
                                                                fullWidth
                                                            />
                                                        }}
                                                        onInputChange={(event, val) => {
                                                            if (event !== null){
                                                                this.setState({
                                                                    studentName: val
                                                                })
                                                                if (val === ""){
                                                                    this.state.studentId = -1;
                                                                }
                                                            }
                                                        }}
                                                        onChange={(e, val) => {
                                                            if (val?.id != undefined){
                                                                this.setState({
                                                                    studentId: val?.id,
                                                                    studentName: val?.fullName,
                                                                })
                                                            }else {
                                                                this.setState({
                                                                    studentId: -1,
                                                                    studentName: "",
                                                                })
                                                            }
                                                            // this.getListPeopleInCharge()
                                                        }}

                                                    />
                                                </div>
                                                <div className="col-6 d-flex mb-2"></div>
                                                <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                    <label className="col-4 label-item pl-0">Chọn điểm đón xe bus</label>
                                                    <select
                                                        className="form-control kt-input pd-4-input hei-input"
                                                        value={this.state.busStopId}
                                                        onChange={(e) => {
                                                            this.setState({
                                                                busStopId: e.target.value
                                                            })
                                                        }}
                                                    >
                                                        <option value="-1">Chọn điểm đón</option>
                                                        {this.renderBusStop()}
                                                    </select>
                                                </div>
                                                <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                    <label className="col-4 label-item pl-0">Địa chỉ đón gần nhà nhất</label>
                                                    <input
                                                        placeholder="Nhập Số nhà-Đường-Quận-Huyện"
                                                        maxLength={255} type="text"
                                                        className="form-control shadow-none"
                                                        value={this.state.addressHome}
                                                        onChange={(event) => {
                                                            this.setState({
                                                                addressHome: event.target.value
                                                            })
                                                        }}
                                                    />
                                                </div>
                                                <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                    <label className="col-4 label-item pl-0">Loại dịch vụ xe bus</label>
                                                    <select
                                                        className="form-control kt-input pd-4-input hei-input"
                                                        value={this.state.busTypePos}
                                                        onChange={(e) => {
                                                            let pos = parseInt(e.target.value)
                                                            if (pos > -1 && this.state.busRouteType.length > 0){
                                                                let priceObj = this.state.busRouteType[pos]
                                                                let totalMoney = parseFloat(priceObj.price)*parseInt(this.state.month)
                                                                this.setState({
                                                                    busRouteTypeId: parseInt(priceObj.id),
                                                                    price: parseFloat(priceObj.price),
                                                                    totalMoney: totalMoney,
                                                                    busTypePos: pos,
                                                                })
                                                            }else {
                                                                this.setState({
                                                                    busRouteTypeId: -1,
                                                                    busTypePos: -1,
                                                                    totalMoney:0,
                                                                })
                                                            }
                                                        }}
                                                    >
                                                        <option value="-1">Chọn loại dịch vụ xe bus</option>
                                                        {this.renderBusType()}
                                                    </select>
                                                </div>
                                                <div className="col-6 d-flex mb-2">Giá: <b> {Utils.formatMoney(this.state.price)}</b> VNĐ</div>
                                                <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                    <label className="col-4 label-item pl-0">Số tháng đóng phí xe bus</label>
                                                    <select
                                                        className="form-control kt-input pd-4-input hei-input"
                                                        value={this.state.month}
                                                        onChange={(e) => {
                                                            this.setState({
                                                                month: e.target.value
                                                            }, ()=>{
                                                                let pos = parseInt(this.state.busTypePos)
                                                                if (pos > -1 && this.state.busRouteType.length > 0){
                                                                    let priceObj = this.state.busRouteType[pos]
                                                                    let totalMoney = parseFloat(priceObj.price)*parseInt(this.state.month)
                                                                    this.setState({
                                                                        busRouteTypeId: parseInt(priceObj.id),
                                                                        totalMoney: totalMoney,
                                                                        busTypePos: pos,
                                                                    })
                                                                }else {
                                                                    this.setState({
                                                                        busRouteTypeId: -1,
                                                                        busTypePos: -1,
                                                                        totalMoney:0,
                                                                    })
                                                                }
                                                            })
                                                        }}
                                                    >
                                                        <option value="0">Chọn số tháng đăng ký</option>
                                                        {this.renderMonthFee()}
                                                    </select>
                                                </div>
                                                <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                    <label className="col-4 label-item pl-0">Ngày bắt đầu dịch vụ</label>
                                                    <DatePicker
                                                        locale="vi"
                                                        className="w-auto  form-control kt-input pd-4-input hei-input"
                                                        selected={this.state.startDay === '' ? null : new Date(this.state.startDay)}
                                                        minDate={new Date()}
                                                        dateFormat="dd-MM-yyyy"
                                                        showMonthDropdown
                                                        showYearDropdown
                                                        onChange={
                                                            (date) => {
                                                                try {
                                                                    this.setState({
                                                                        startDay: date,
                                                                    })
                                                                }catch (e) {

                                                                }
                                                            }
                                                        }
                                                    />
                                                </div>
                                                <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                    <label className="col-4 label-item pl-0">Tiền giảm trừ</label>
                                                    <input
                                                        placeholder="Nhập số tiền giảm trừ"
                                                        maxLength={255} type="text"
                                                        className="form-control shadow-none"
                                                        value={Utils.formatMoney(this.state.discount)}
                                                        onChange={(event) => {
                                                            this.setState({
                                                                discount: event.target.value
                                                            })
                                                        }}
                                                    />
                                                </div>
                                                <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                    <label className="col-4 label-item pl-0">Lý do giảm trừ</label>
                                                    <input
                                                        placeholder="Nhập lý do giảm trừ"
                                                        maxLength={255} type="text"
                                                        className="form-control shadow-none"
                                                        value={this.state.reasonDiscount}
                                                        onChange={(event) => {
                                                            this.setState({
                                                                reasonDiscount: event.target.value
                                                            })
                                                        }}
                                                    />
                                                </div>
                                                <div className="col-12 d-flex mb-2">
                                                    <label className="col-4 label-item pl-0">Tổng tiền(Tổng tiền dịch vụ - Tiền giảm trừ)</label>
                                                    <label className="col-8 label-item pl-0"><b>{this.getTotalMoney()} đ</b></label>
                                                </div>
                                                <div className="align-right col-12">
                                                    <div className="d-flex justify-content-center align-center mt-3 mb-2">
                                                        <button
                                                            type="button"
                                                            className="ml-4 border-1-s background-btn type-button-fix btn btn-primary shadow-none"
                                                            disabled={this.state.busRouteId < 0}
                                                            onClick={()=> {
                                                                this.onCreate()
                                                            }}
                                                        >
                                                            Đăng ký
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-12 d-flex mb-2 bg-top-title mt-2">
                                                Danh sách học sinh đã đăng ký xe bus
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mt-2 mb-3">
                                                <label className="label-item col-md-4">Điểm đón xe bus</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.filterBusStopId}
                                                    onChange={(e) => {
                                                        let id = parseInt(e.target.value)
                                                        this.setState({
                                                            filterBusStopId: id
                                                        })
                                                    }}
                                                >
                                                    <option value="-1">Chọn điểm đón</option>
                                                    {this.renderBusStop()}
                                                </select>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mt-2 mb-3">
                                                <label className="label-item col-md-4">Trạng thái dịch vụ</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.stateService}
                                                    onChange={(e) => {
                                                        this.setState({
                                                            stateService: e.target.value
                                                        })
                                                    }}
                                                >
                                                    <option value="NEW_REGISTER">Đăng ký mới</option>
                                                    <option value="PAID">Đã thanh toán</option>
                                                    <option value="CANCEL">Đã hủy</option>
                                                    <option value="ACTIVE">Hoạt động</option>
                                                    <option value="INACTIVE">Khóa</option>
                                                </select>
                                            </div>
                                            <div className="card col-12">
                                                <div className="p-0 mb-3">
                                                    <div className="table-wrapper">
                                                        <table
                                                            className="table table-striped table-data table-responsive table-bordered">
                                                            <table className="table">
                                                                <thead>
                                                                <TableHeader
                                                                    header={header}
                                                                    clickSort={data => {
                                                                    }}
                                                                />
                                                                </thead>
                                                                {!busUserServiceRes ||
                                                                 busUserServiceRes.length == 0 ? (
                                                                    <tbody>
                                                                    <tr>
                                                                        <td colSpan={12}>
                                                                            <div className="text-center">
                                                                                Không có dữ liệu
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                    </tbody>
                                                                ) : (
                                                                    <tbody>
                                                                    {busUserServiceRes &&
                                                                        busUserServiceRes.length > 0 &&
                                                                        busUserServiceRes?.map((row, index) => (
                                                                            <tr style={{height: 50}}>
                                                                                <td style={{textAlign: "center"}} scope="row">
                                                                                    {" "}
                                                                                    {this.state.pageNumber * this.state.pageSize +
                                                                                        index +
                                                                                        1}
                                                                                </td>
                                                                                <td style={{textAlign: "left"}} scope="row">
                                                                                    {row.fullName}
                                                                                </td>
                                                                                <td style={{textAlign: "left"}} scope="row">
                                                                                    {row.busRouteTypeRes?.busTypeRes?.name}
                                                                                </td>
                                                                                <td style={{textAlign: "center"}}>
                                                                                    {row.busStopRes?.name}<a href={row.busStopRes?.location==""?"https://www.google.com/maps": row.busStopRes?.location} target="_blank" rel="noopener noreferrer">
                                                                                    (Ấn để mở Google Map)
                                                                                </a>
                                                                                </td>
                                                                                <td style={{textAlign: "left"}}>
                                                                                    {Utils.formatMoney(row.busRouteTypeRes.price)}đ
                                                                                </td>
                                                                                <td style={{textAlign: "left"}}>
                                                                                    {row.priceType}
                                                                                </td>
                                                                                <td style={{textAlign: "left"}}>
                                                                                    {Utils.formatMoney(row.discount)}đ
                                                                                </td>
                                                                                <td style={{textAlign: "left"}}>
                                                                                    {row.reasonDiscount}
                                                                                </td>
                                                                                <td style={{textAlign: "center"}}>
                                                                                    {this.getStateUserReg(row.state)}
                                                                                </td>
                                                                                <td style={{textAlign: "center"}}>

                                                                                    <button className="btn btn-action p-2"
                                                                                            title='Chi tiết'
                                                                                            style={{cursor: 'pointer'}}
                                                                                            onClick={() => {
                                                                                                this.setState({itemSelected: row, showModalDetailService: true})
                                                                                            }}
                                                                                    >
                                                                                        <i className="ti-book"/>
                                                                                    </button>
                                                                                    {(row.state =="NEW_REGISTER" || row.state =="PAID" || row.state =="ACTIVE") &&
                                                                                        <button className="btn btn-action p-2"
                                                                                                title='Hủy dịch vụ'
                                                                                                style={{cursor: 'pointer'}}
                                                                                                onClick={() => {
                                                                                                    this.setState({itemSelected: row, showModalCancelService: true})
                                                                                                }}
                                                                                        >
                                                                                            <i className="ti-close"/>
                                                                                        </button>}
                                                                                </td>
                                                                            </tr>
                                                                        ))}
                                                                    </tbody>
                                                                )}
                                                            </table>
                                                        </table>
                                                    </div>
                                                    <div className="pagination-right">
                                                        <Pagination
                                                            activePage={this.state.pageNumber}
                                                            itemsCountPerPage={this.state.pageSize}
                                                            totalItemsCount={this.state.totalItem}
                                                            changeHandler={page => this.handleChangePage(page)}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="align-right col-12">
                                    <div className="d-flex justify-content-center align-center mt-3 mb-2">
                                        <button
                                            type="button"
                                            className="ml-4 border-1-s background-btn type-button-fix btn btn-primary shadow-none"
                                            disabled={this.state.fullName == ""}
                                            onClick={()=> {
                                                this.onCreate()
                                            }}
                                        >
                                            Lưu
                                        </button>
                                        <button
                                            type="button"
                                            className="ml-4 border-1-s type-button-fix btn btn-light shadow-none"
                                        >
                                            <Link
                                                style={{color: '#000'}}
                                                to={{
                                                    pathname: "/ad-sas-school/danh-sach-dang-ky-xe-bus"
                                                }}
                                            >
                                                Hủy bỏ
                                            </Link>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ModalCancelRegisterBus
                    show={this.state.showModalCancelService}
                    onHide={() => this.setState({showModalCancelService: false})}
                    onRefresh={() => this.updateViewCancel()}
                    item={this.state.itemSelected}
                    routeBusName={this.state.routeBusName}
                />
                <ModalDetailRegisterBus
                    show={this.state.showModalDetailService}
                    onHide={() => this.setState({showModalDetailService: false})}
                    onRefresh={() =>{}}
                    item={this.state.itemSelected}
                />
            </div>
        )
    }
}
export default withRouter(CreateBusRegisterManagement)